export const comparisonDateRangeOptions = [
    { label: 'No comparison', value: false },
];
